/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Network_UnreachableInputs */



/**
* | output |
* | --- |
* | "Couldn't reach the server. Check your connection and try again." |
*
* @param {Error_Network_UnreachableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const error_network_unreachable = /** @type {((inputs?: Error_Network_UnreachableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Network_UnreachableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile raggiungere il server. Controlla la connessione e riprova.")
	return /** @type {LocalizedString} */ ("Couldn't reach the server. Check your connection and try again.")
});